import React from "react";

const SpecialText = ({ variant, children, className = "" }) => {
  return (
    <>
      {variant === "frame-xxl" && (
        <p
          className={`
          ${className} hero-display font-inter font-bold`}
        >
          {children}
        </p>
      )}

      {variant === "frame-xl" && (
        <p
          className={`
          ${className} main-display font-inter font-bold`}
        >
          {children}
        </p>
      )}

      {variant === "frame-l" && (
        <p
          className={`
          ${className} section-display font-inter font-bold`}
        >
          {children}
        </p>
      )}

      {variant === "frame-m" && (
        <p
          className={`
          ${className} sub-display font-inter font-bold`}
        >
          {children}
        </p>
      )}

      {variant === "frame-s" && (
        <p
          className={`
          ${className} highlight-title font-inter font-bold`}
        >
          {children}
        </p>
      )}

      {variant === "frame-xs" && (
        <p
          className={`
          ${className} feature-title font-inter capitalize`}
        >
          {children}
        </p>
      )}

      {variant === "number-3xl" && (
        <p
          className={`
          ${className} number-3xl font-inter font-bold`}
        >
          {children}
        </p>
      )}
      {variant === "number-2xl" && (
        <p
          className={`
          ${className} number-2xl font-inter font-bold`}
        >
          {children}
        </p>
      )}

      {variant === "number-xl" && (
        <p
          className={`
          ${className} number-xl font-inter font-bold`}
        >
          {children}
        </p>
      )} 

      {variant === "MetricMajor" && (
        <p
          className={`
          ${className} metric-major font-inter font-bold`}
        >
          {children}
        </p>
      )}

      {variant === "MetricMedium" && (
        <p
          className={`
          ${className} metric-medium font-inter font-bold`}
        >
          {children}
        </p>
      )}

      {variant === "MetricMinor" && (
        <p
          className={`
          ${className} metric-medium font-inter font-bold`}
        >
          {children}
        </p>
      )}

      {/* Usage : Used on Pricing cards package price */}
      {variant === "ExtraLargeNumber" && (
        <p
          className={`
          ${className} metric-major font-inter font-bold`}
        >
          {children}
        </p>
      )}

      {/* Usage : Used on Rankings like 4.1 by 5 */}
      {variant === "LargeNumber" && (
        <p
          className={`
          ${className} font-inter font-bold leading-[1.4] tracking-[0px] text-[23px] sm:text-[28px] md:text-[32px] lg:text-[28px] xl:text-[32px] 2xl:text-[34px]`}
        >
          {children}
        </p>
      )}

      {/* {variant === "MetricMedium" && (
        <p
          className={`
          ${className} metric-medium font-inter font-bold`}
        >
          {children}
        </p>
      )} */}

       {/* Usage : Counter for dashboards tabs */}
       {variant === "TabsCounter" && (
        <p
          className={`
          ${className} counter-number font-inter font-bold`}
        >
          {children}
        </p>
      )}
      {/* o	Usage: Fine print, disclaimers, legal notes. snips etc */}
      {variant === "FootNoteDisclaimer" && (
        <p
          className={`
          ${className} footer-legal font-inter`}
        >
          {children}
        </p>
      )}

      {(variant === "InputTooltip" || variant === "InputHelper") && (
        <p
          className={`
          ${className} input-tooltip font-inter normal-case`}
        >
          {children}
        </p>
      )}
      
      {variant === "FormValidation" && (
        <p
          className={`
          ${className} form-validation font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "SystemMessage" && (
        <p
          className={`
          ${className} system-message font-inter`}
        >
          {children}
        </p>
      )}

      {/* Profile Primary — title (main profile, post header) */}
      {(variant === "ProfileName" || variant === "ProfilePrimary") && (
        <p
          className={`
          ${className} profile-primary font-inter`}
        >
          {children}
        </p>
      )}

      {/* Profile Secondary — under profile or post card, category */}
      {(variant === "ProfileSecondary" || variant === "ListingText") && (
        <p
          className={`
          ${className} profile-secondary font-inter`}
        >
          {children}
        </p>
      )}

      {/* Profile Meta — category, location */}
      {(variant === "ProfileMeta" || variant === "UserDetails") && (
        <p
          className={`
          ${className} profile-meta font-inter`}
        >
          {children}
        </p>
      )}

      {/* Profile Micro — secondary location / category detail */}
      {(variant === "OccupationLocation" || variant === "ProfileMicro") && (
        <p
          className={`
          ${className} profile-micro font-inter`}
        >
          {children}
        </p>
      )}
      {variant === "NavigationPath" && (
        <p
          className={`
          ${className} navigation-path font-inter`}
        >
          {children}
        </p>
      )}

      {/* Timestamp / views — dates and stats */}
      {(variant === "Date" || variant === "DateStamp" || variant === "Timestamp") && (
        <p
          className={`
          ${className} timestamp font-inter`}
        >
          {children}
        </p>
      )}

      {/* o	Usage: Displaying when needs paragraph size text or low (value /0 ) Labelling. */}
      {/* {variant === "ParagraphSizeNumber" && (
        <p
          className={`
          ${className} font-inter font-normal text-[12px] leading-[1.4] tracking-[0px] sm:text-[12px] md:text-[12px] lg:text-[13px] xl:text-[14px] 2xl:text-[15px]`}
        >
          {children}
        </p>
      )} */}

      {/* o	Usage: Displaying counter for services cards, icons Numbers, Review counter number. */}
      {variant === "Counter" && (
        <p
          className={`
          ${className} counter-number font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "IntroParagraph" && (
        <p
          className={`
          ${className} intro-paragraph font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "SectionDesc" && (
        <p
          className={`
          ${className} standard-description font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "Caption" && (
        <p
          className={`
          ${className} visual-caption font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "FeatureTitle" && (
        <p
          className={`
          ${className} feature-title font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "TableHeader" && (
        <p
          className={`
          ${className} table-header font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "TableBody" && (
        <p
          className={`
          ${className} table-body font-inter`}
        >
          {children}
        </p>
      )}

    </>
  );
};

export default SpecialText;
